"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _ssrConfig = require("@engaging-tech/ssr-config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-console */
// Repeatedly check Marker.io is loaded, up to a max of 10 times
var awaitMarkerLoad = function awaitMarkerLoad() {
  return new Promise(function (resolve, reject) {
    var count = 0;
    var intervalId = setInterval(function () {
      if (count > 10) {
        clearInterval(intervalId);
        reject();
      }

      if (typeof window !== "undefined" && window.Marker) {
        clearInterval(intervalId);
        resolve();
      }

      count += 1;
    }, 100);
  });
};

var onLoad = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(captureCallback, metaData, debug) {
    var config;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = (0, _ssrConfig.getConfig)();
            _context.prev = 1;
            _context.next = 4;
            return awaitMarkerLoad();

          case 4:
            window.markerLogDumped = false;
            window.Marker.on("capture", function () {
              if (metaData) {
                window.Marker.setCustomData(metaData);
              } // Conditional to stop this getting triggered multiple times per 1 click


              if (!window.markerLogDumped && captureCallback) {
                captureCallback();
              }

              window.markerLogDumped = true;
            });
            window.Marker.on("feedbacksent", function () {
              window.markerLogDumped = false;
            });
            window.Marker.on("feedbackdiscarded", function () {
              window.markerLogDumped = false;
            });
            window.Marker.on("feedbackerror", function () {
              window.markerLogDumped = false;
            });

            if (!config.isProd && window.location.hostname !== "localhost") {
              setTimeout(function () {
                window.Marker.show();
                console.log("Setting visibility of Marker.io button to true");
              }, 3000);
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            if (debug) console.log("MarkerIOLoadError", _context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function onLoad(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}(); // Place this component within the starting file of react. It attaches listeners to Marker.io so when a user reports a bug, it triggers a callback and attaches metadata


var MarkerInfoDumper = function MarkerInfoDumper(_ref2) {
  var captureCallback = _ref2.captureCallback,
      metaData = _ref2.metaData,
      debug = _ref2.debug;
  (0, _react.useEffect)(function () {
    onLoad(captureCallback, metaData, debug); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
};

var _default = MarkerInfoDumper;
exports["default"] = _default;